import type { AnchorHTMLAttributes, ReactNode } from "react";

type ButtonProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  children: ReactNode;
  tone?: "primary" | "ghost";
};

export function Button({ children, tone = "primary", className = "", ...props }: ButtonProps) {
  return (
    <a className={`button button--${tone} ${className}`.trim()} {...props}>
      <span>{children}</span>
    </a>
  );
}
